import { leaveBreadcrumb } from 'cfa-react-logging';
import ooeConstants from '../constants';
import { NutritionResponse } from '../types/nutrition';
import { handleFetchFail, parseAsJson } from '../util/httpUtils';
import { MenuResponse } from './types';

export const getCateringMenu = async ({
  location,
  destination,
}: {
  location: string;
  destination: string;
}): Promise<MenuResponse> => {
  const baseUrl = ooeConstants.URL.MENU;
  const url = `${baseUrl}/locations/3.2/${location}/menu/client/catering/${destination}`;
  const method = 'GET';
  const bugsnag = {
    breadcrumb: `Get Catering Menu For ${destination} Destination`,
    errorClass: ooeConstants.BUGSNAG_ERRORCLASS_ORDERS,
    context: 'Get Catering Menu',
  };

  leaveBreadcrumb(bugsnag.breadcrumb, {
    url,
    method,
    context: bugsnag.context,
  });

  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };

  const response = await fetch(url, { method, headers }).catch(handleFetchFail);
  return parseAsJson(response);
};

export const getMenuNutrition = async ({ location }: { location: string }): Promise<NutritionResponse> => {
  const baseUrl = ooeConstants.URL.ORDERS;
  const url = `${baseUrl}/locations/4.0/${location}/menu/client/nutrition`;
  const method = 'GET';
  const bugsnag = {
    breadcrumb: `Get Menu Nutrition`,
    errorClass: ooeConstants.BUGSNAG_ERRORCLASS_ORDERS,
    context: 'Get Menu Nutrition',
  };

  leaveBreadcrumb(bugsnag.breadcrumb, {
    url,
    method,
    context: bugsnag.context,
  });

  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };

  const response = await fetch(url, { method, headers }).catch(handleFetchFail);
  return parseAsJson(response);
};
